export const generic_errors = {
    'eng': {
        INCOMPLETE_FORM: 'Fill in the missing fields',
        ERROR_MESSAGE: 'An error occurred',
        PSW_DONT_MATCH: 'The password confirmation does not match',
    }
}